import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import WarehousesList from './WarehousesList'

export default function Warehouses() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/warehouses" component={WarehousesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}